<template>
  <div>
     <template class="table-head">
        <el-table style="width: 100%" @current-change="handleCurrentChange" highlight-current-row  :data="distributionList" border height="200" ref="dragTable">
            <el-table-column align="center" show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width" v-for="(item, index) in distributionColumnItem" :key="index">
                    <template slot-scope="scope">
                        <span class="center">
                            <el-input :class="{red: scope.row.hasValue}" clearable
                                v-if="item.prop==='supplierAmount'"
                                v-model="scope.row[item.prop]" :disabled ="ifConfirm"></el-input>
                            <el-input clearable maxlength="50" v-else-if="item.prop==='supplierMsg'" v-model.trim="scope.row[item.prop]" :disabled ="ifConfirm" ></el-input>
                            <span v-else>{{scope.row[item.prop]}}</span>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        <div class="pagination">
            <el-pagination small layout="prev, pager, next" @current-change="pageChange" :total="total"></el-pagination>
        </div>
     </template>
  </div>
</template>

<script>
export default {
    props: {
        distributionColumnItem: {
            type: Array
        },
        tableDataLists: {
            type: Object
        },
        distributionLenth: {
            type: Number,
            default: 0
        },
        ifConfirm: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            distributionList: [],
            supplierAmountTem: [],
            total: 0
        };
    },
    methods: {
        handleCurrentChange(row) {
            row && this.$emit('apBillDeDetail', 1, row); // 调用费用明细的事件， 页码， 参数
        },
        pageChange(page) {
            this.$emit('apBillDetail', page);
        },
        saveDistributionDetails() { // 保存
            const datas = [];
            for (let i = 0; i < this.distributionList.length; i++) {
                if (this.distributionList[i].supplierAmount === '' || this.distributionList[i].supplierAmount === undefined) {
                    return this.$message.warning('确认费用金额不能为空');
                }
                if (Number(this.distributionList[i].supplierAmount) !== this.distributionList[i].amount &&
                (this.distributionList[i].supplierMsg === undefined || this.distributionList[i].supplierMsg === '')) {
                    this.$message.warning('确认金额不一致，请备注原因');
                    return;
                } else {
                    const data = { // 回传出去
                        feeTaskCode: this.distributionList[i].feeTaskCode,
                        jobId: this.distributionList[i].jobId,
                        supplierAmount: this.distributionList[i].supplierAmount,
                        supplierMsg: this.distributionList[i].supplierMsg
                    };
                    datas.push(data);
                }
            }
            this.$emit('saveApBillDetail', datas);
        },
        confirm() { // 确认提交
            this.tableArray = this.distributionList.every(item => {
                return item.supplierAmount !== undefined && item.supplierAmount !== '';
            });
            if (!this.tableArray) {
                return this.$message.warning('确认费用金额不能为空');
            } else {
                for (let i = 0; i < this.distributionList.length; i++) {
                    if (Number(this.distributionList[i].supplierAmount) !== this.distributionList[i].amount &&
                (this.distributionList[i].supplierMsg === undefined || this.distributionList[i].supplierMsg === '')) {
                        return this.$message.warning('确认金额不一致，请备注原因');
                    }
                }
            }
            if (this.distributionList.map(item => item.supplierAmount).toString() === this.supplierAmountTem.toString()) {
                this.$emit('confirmOk');
            } else {
                return this.$message.warning('数据已更改，请先保存之后再提交');
            }
        }

    },
    watch: {
        tableDataLists: {
            handler(newValue) {
                this.distributionList = JSON.parse(JSON.stringify(newValue.list));
                this.supplierAmountTem = newValue.list.map(item => item.supplierAmount);
                this.total = newValue.totalCount;
            },
            deep: true
        }

    }

};
</script>

<style lang="less">

</style>